/* eslint-disable indent */
import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import isEmpty from "../../../validation/isEmpty";
import {
  TimeStampIntoHours,
  tableSkeleton
} from "../../../constant/helper/helper";
import PropTypes from "prop-types";

const MissingList = ({
  hrLoading,
  changeSelectedStatus,
  missingListData
}) => {
  if (hrLoading) {
    return <tr>{tableSkeleton(12)}</tr>;
  } else if (!isEmpty(missingListData)) {
    return missingListData.map((missingDetail, index) => (
      <tr key={index} style={{ fontSize: "12px" }}>
        <td>
          <span className="">{index + 1}</span>
        </td>

        <td>
          <span className="">{missingDetail.workerId}</span>
        </td>
        <td>
          <Link to={`/hr/user/all-users/${missingDetail.employeeId}`}>
            {missingDetail.workerFullName}
          </Link>
        </td>

        <td>
          <span className="">
            {moment(missingDetail.date).format("DD-MM-YYYY")}
          </span>
        </td>
        <td>
          <span className="">
            {!isEmpty(missingDetail.regularizedType) &&
              missingDetail.regularizedType}
          </span>
        </td>
        <td>
          <span className="">{missingDetail.locationName}</span>
        </td>
        <td>
          <span className="">{missingDetail.regularizedRemark}</span>
        </td>

        <td>
          <span className="">
            {TimeStampIntoHours(missingDetail.inTime)}
          </span>
        </td>
        <td>
          <span className="">
            {TimeStampIntoHours(missingDetail.outTime)}
          </span>
        </td>

        <td>
          <span className="">
            {moment(missingDetail.createdAt).format("DD-MM-YYYY")}
          </span>
        </td>

        <td>
          <span
            className={
              missingDetail.missingAttendanceStatus === "APPLIED"
                ? "badge badge-info text-white"
                : missingDetail.missingAttendanceStatus === "APPROVED"
                ? "badge badge-success text-white"
                : missingDetail.missingAttendanceStatus === "REJECTED"
                ? "badge badge-danger text-white"
                : missingDetail.missingAttendanceStatus === "HOLD"
                ? "badge badge-warning text-white"
                : "badge badge-success text-white"
            }
          >
            {missingDetail.missingAttendanceStatus}
          </span>
        </td>
        <td>
          <td className="text-center">
            <span className="">
              <select
                value={missingDetail.missingAttendanceStatus}
                onChange={(e) =>
                  changeSelectedStatus(e, missingDetail)
                }
                placeholder="Select Status"
              >
                <option value="APPLIED">APPLIED</option>
                <option value="APPROVED">APPROVED</option>
                <option value="REJECTED">REJECTED</option>
              </select>
            </span>
          </td>
        </td>
      </tr>
    ));
  } else {
    return <></>;
  }
};

MissingList.propTypes = {
  hrLoading: PropTypes.bool.isRequired,
  missingListData: PropTypes.array.isRequired,
  changeSelectedStatus: PropTypes.func.isRequired
};

export default MissingList;
